import { Params, ParamMap } from '@angular/router';

export const NOT_READY_TO_INVOICE_KEY = 'not-ready-to-invoice';

export const toNotReadyToInvoiceParams = (args: {
	notReadyToInvoice?: boolean;
}): Params => ({
	[NOT_READY_TO_INVOICE_KEY]: args.notReadyToInvoice
		? args.notReadyToInvoice
		: undefined,
});

export const toNotReadyToInvoiceListArgs = (
	paramMap: ParamMap
): { notReadyToInvoice?: boolean } =>
	paramMap.has(NOT_READY_TO_INVOICE_KEY)
		? {
				notReadyToInvoice:
					paramMap.get(NOT_READY_TO_INVOICE_KEY) === 'true',
		  }
		: undefined;
